/* eslint-disable react/prop-types */
import Table from 'Shared/components/DataTable/Table'
import restClient from 'Shared/hooks/restClient'
import { ComponentProps, FC } from 'react'
import BackButton from 'Shared/components/BackButton'

const ManageFlowTemplates: FC<{ clientId: string }> = ({ clientId }) => {
  const reloadTable = () => {
    window.$('table').DataTable().ajax.reload()
  }

  const handleTableClick = (e: React.MouseEvent<HTMLElement>) => {
    const target = e.target as HTMLElement

    if (target.classList.contains('archive-flow-template')) {
      const flowTemplateId = target.dataset.flowTemplateId
      if (window.confirm('Are you sure you want to archive this template? Existing pages using it will continue to work, but you won\'t be able to start new pages with it.')) {
        restClient.post(`/api/flow_templates/${flowTemplateId}/archive`).then(reloadTable)
      }
    } else if (target.classList.contains('restore-flow-template')) {
      const flowTemplateId = target.dataset.flowTemplateId
      restClient.post(`/api/flow_templates/${flowTemplateId}/restore`).then(reloadTable)
    }
  }

  const tableProps: ComponentProps<typeof Table> = {
    table: 'flowTemplates',
    scope: { clientId },
    language: { emptyTable: 'There are no page or ballot templates yet' },
    onClick: handleTableClick,
  }

  const createTemplate = () => {
    restClient.post('/api/flow_templates', {'name': 'New Page Template'}).then((res) => {
      window.location.href = `/admin/settings/flow_templates/${res.data.id}/edit`
    })
  }

  return (
    <>
      <div className="header">
        <BackButton url="/admin/settings" />
        <h1>Page and Ballot Templates</h1>
        <div className="actions">
          <button className="button primary" type="button" onClick={createTemplate}>
            Add
          </button>
        </div>
      </div>
      <div className="section">
        <div className="box">
          <Table {...tableProps} />
        </div>
      </div>
    </>
  )
}

export default ManageFlowTemplates
